module.exports = __webpack_public_path__ + "img/zhiyuan.1630993415105.png";